/* eslint-disable */
export const stringfy = string => string.toString().toLowerCase()
  .replace(/[àÀáÁâÂãäÄÅåª]+/g, 'a')// Special Characters #1
  .replace(/[èÈéÉêÊëË]+/g, 'e')// Special Characters #2
  .replace(/[ìÌíÍîÎïÏ]+/g, 'i')// Special Characters #3
  .replace(/[òÒóÓôÔõÕöÖº]+/g, 'o')// Special Characters #4
  .replace(/[ùÙúÚûÛüÜ]+/g, 'u')// Special Characters #5
  .replace(/[ýÝÿŸ]+/g, 'y')// Special Characters #6
  .replace(/[ñÑ]+/g, 'n')// Special Characters #7
  .replace(/[çÇ]+/g, 'c')// Special Characters #8
  .replace(/[ß]+/g, 'ss')// Special Characters #9
  .replace(/[Ææ]+/g, 'ae')// Special Characters #10
  .replace(/[Øøœ]+/g, 'oe')// Special Characters #11
  .replace(/[%]+/g, 'pct')// Special Characters #12
  .replace(/\s+/g, '-')// Replace spaces with -
  .replace(/[^\w\-]+/g, '')// Remove all non-word chars
  .replace(/\-\-+/g, '-')// Replace multiple - with single -
  .replace(/^-+/, '')// Trim - from start of text
  .replace(/-+$/, '');// Trim - from end of text

export const firstLetterUppercase = string => {
  const index = string.search(/[a-zàáâãäåèéêëìíîïòóôõöùúûüýÿñç]/i);
  if (index > 0) {
    return string.slice(0, index) + string.charAt(index).toUpperCase() + string.slice(index + 1);
  }
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const capitalize = string => {
  const arrayPhrase = string.split(' ');
  const preposition = ['da', 'de', 'do', 'na', 'nas', 'no', 'nos', 'das', 'dos', 'a', 'as', 'ao', 'aos', 'o', 'os', 'e', 'é', 'em', 'para', 'por'];
  for (var i = 0; i < arrayPhrase.length; i++) {
    arrayPhrase[i] = arrayPhrase[i].toLowerCase().trim();
    if ( !preposition.includes(arrayPhrase[i]) ) {
      arrayPhrase[i] = firstLetterUppercase( arrayPhrase[i] );
    }
  }

  return arrayPhrase.join(' ');
};

export const capitalizePhrase = string => {
  string = string.toLowerCase();
  const arrayPhrase = string.split('.');
  arrayPhrase[0] = firstLetterUppercase( arrayPhrase[0].trim() );

  for (var i = 1; i < arrayPhrase.length; i++) {
    arrayPhrase[i] = firstLetterUppercase( arrayPhrase[i].trim() );
  }

  return arrayPhrase.join('. ');
};
